var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('l-map',{ref:"map",staticStyle:{"width":"100%","height":"100%","position":"relative","background":"black"},attrs:{"options":_vm.option}},[_c('l-tile-layer',{staticStyle:{"margin":"0 auto"},attrs:{"url":_vm.tifLayer,"tms":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }